import api from "../../../utils/service/api";
import {
  campaignKeyFromCampaignId,
  campaignKeyFromSessionId,
  rememberRecruitmentSessionTokenFromResponse,
  recruitmentAuthHeaders,
} from "../../../utils/constants/recruitmentSessionAuth";

export const actionGetRecruiment = (params) => {
  return api({
    method: "GET",
    url: `/api/recruitment/campaigns`,
    params,
  });
};

export const actionEnsureRecruitmentChatSession = async (data) => {
  const campaignKey = campaignKeyFromCampaignId(data?.campaign_id);
  const response = await api({
    method: "POST",
    url: `/api/recruitment/chat/sessions`,
    data,
    withCredentials: true,
  });
  rememberRecruitmentSessionTokenFromResponse(response, campaignKey);
  return response;
};

export const actionSendRecruitmentChatMessage = async (data) => {
  const campaignKey = campaignKeyFromSessionId(data?.session_id);
  const response = await api({
    method: "POST",
    url: `/api/recruitment/chat/messages`,
    data,
    withCredentials: true,
    headers: recruitmentAuthHeaders(campaignKey),
  });
  rememberRecruitmentSessionTokenFromResponse(response, campaignKey);
  return response;
};

export const actionUploadRecruitmentFile = async (formData, campaignId) => {
  const campaignKey = campaignKeyFromCampaignId(campaignId);
  const response = await api({
    method: "POST",
    url: `/api/recruitment/files/upload`,
    data: formData,
    withCredentials: true,
    headers: recruitmentAuthHeaders(campaignKey),
  });
  rememberRecruitmentSessionTokenFromResponse(response, campaignKey);
  return response;
};

export const actionUploadRecruitmentCV = async (candidateId, data, campaignId) => {
  const campaignKey = campaignKeyFromCampaignId(campaignId);
  const response = await api({
    method: "PUT",
    url: `/api/recruitment/files/cv-repository/${candidateId}/cv`,
    data,
    withCredentials: true,
    headers: recruitmentAuthHeaders(campaignKey),
  });
  rememberRecruitmentSessionTokenFromResponse(response, campaignKey);
  return response;
};
